import { ConnectionRequest } from "@/lib/store/Realtime/message.types";
import { useConnectStore } from "@/dentlab/src/store/Connect";
import { Tables } from "@/lib/supabase/supabaseTypesImport";

interface ConnectionRequestBlockProps {
	content: ConnectionRequest;
	brandName: string;
}	

export const ConnectionRequestBlock: React.FC<ConnectionRequestBlockProps> = ({
	content,
	brandName,
}) => {

	return (
		<div>
			<div className="text-sm text-gray-500">
				Neue Anfrage, auf dentDESK.ch zusammenzuarbeiten:
			</div>
			<div className="text-sm text-gray-500">{content.message}</div>
			<div className="text-sm font-semibold text-gray-500"> {brandName} </div>
		</div>
	);
};
